module.exports = __webpack_public_path__ + "static/media/HOTCROSS.49763539.svg";